import React, { useContext } from 'react'
import { PermissionGuard } from '../../../../components/PermissionGuard'
import { Box, Button } from '@mui/material'
import { NotificationDataContext } from '../AddEditNotification'

const NavigationButton = (props) => {
    const {isDirty,nextButtonText,disableBackButton} = props
    const {handleBack} = useContext(NotificationDataContext)
  return (
    <PermissionGuard feature='notification' permission={'canCreate'}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
            <Button
                onClick={handleBack}
                disabled = {disableBackButton}
                sx={{ fontSize: '0.75rem' }}
            >
                Back
            </Button>
            <Button
                variant="contained"
                type="submit"
                // disabled={!isDirty}
                sx={{ fontSize: '0.75rem' }}
            >
                {nextButtonText?nextButtonText:'Next'}
            </Button>
        </Box>
    </PermissionGuard>
  )
}

export default NavigationButton
